const data = {
    "Main": "Bosh sahifa",
    "Transportation organization": "Transportni tashkillashtirish",
    "Dispatching": "Dispetcherizatsiya",
    "Sales": "Savdo",
    "Administration": "Ma'muriyat",
    "Logout": "Chiqish",
    "Search": "Qidirish",

    "Trips": "Safarlar",
    "Reporting": "Hisobot",

    "Logs": "Loglar",
    "Cashier action": "Kassir harakati",

    "Pricing": "Raqobatchilar",
    "Tariffs": "Tariflar",
    "Privileges": "Imtiyozlar",
    "Baggage": "Bagaj",
    "Services": "Xizmatlar",

    "Profile": "Profil",
    "My profile": "Mening profilim",

    "Sales reporting": "Savdo hisobotlari",
    "Dispatch reporting": "Dispetcher hisoboti",
    "Transporter reports": "Tashuvchi hisoboti",
    "Reports for Min. Trans.": "Trans. Vaz. uchun hisbot",
    "Reports for Validator.": "Tekshiruvchi hisoboti",

    "Cashier's workplace": "Kassir ish joyi",
    "Ticket selling": "Chipta sotish",
    "Armor redemption": "Выкуп брони",
    "Ticket return": "Chiptalarni qaytarish",
    "Restore ticket": "Chiptani qayta tiklash",

    "Schedule": "Jadval",
    "Areas": "Maydonlar",
    "Bus terminals": "Avtovokzal",
    "Routes": "Yo'nalishlar",
    "Schedule trips": "Safarlarni rejalashtirish",

    "Settings": "Sozlamalar",
    "Options": "Parametrlar",
    "Returns": "Qaytariladi",
    "Booking": "Bron qilish",
    "Booking List": "Bronlar ro'yxati",
    "Work with transporter": "Tashuvchilar bilan ishlash",

    "Transporter": "Tashuvchi",
    "Buses": "Avtobuslar",
    "Bus types": "Avtobus turlari",

    "Employees": "Xodimlar",
    "Roles": "Rollar",

    "Creation - Editing": "Yaratilish - Tahrirlash",
    "Baggage (Editing)": "Bagaj (reja)",
    "Save and close": "Yozing va yoping",
    "Fixed amount": "Ruxsat etilgan miqdor",
    "Interest Amount": "Foiz miqdori",
    "Amount depending on km": "Miqdori km ga bog'liq",
    "Title": "Nomi",
    "Weight to (kg)": "Og'irligi (kg)",
    "Step (km)": "Bosqich (km)",
    "Additional settings": "Qo'shimcha sozlamalar",
    "From (km)": "Dan (km)",
    "To (km)": "Gacha (км)",
    "Price for this step": "Ushbu qadamning narxi",
    "Price": "Narxi",
    "Percent": "Prosent",
    "Action": "Amal",
    "Reservation fee": "Bronga qo'shimcha to'lov",
    "bag for a ticket": "sum biletga",
    "It is allowed to book more than 1 place for a cashier": "Kassir uchun 1dan ortiq joyni bronga kiritish mumkin",
    "Not": "Yo'q",
    "Passenger personal data required": "Yo'lovchi shaxsiy ma'lumotlari kerak",
    "Required": "Majburiy",
    "Not required": "Majburiy emas",
    "Places are again available for sale for": "Joylar yana sotuvga chiqariladi",
    "minutes before departure": "chiqishidan bir necha daqiqa oldin",
    "Booking is removed through": "Bron  olib tashlanadi",
    "minutes": "minut",
    "Yes": "Ha",
    "No": "Yo'q",
    "Editing": "O'zgartirish",
    "Creature": "Yaratish",
    "buses": "avtobuslarni",
    "This field is required": "Bu maydon talab qilinadi",
    "Model": "Model",
    "Driver": "Haydovchi",
    "Number bus": "Avtobus raqami",
    "Create": "Yaratish",
    "Transporters": "Tashuvchilar",
    "Number": "Raqam",
    "Status": "Holat",
    "Active": "Faol",
    "Inactive": "Faol emas",
    "Turn off": "O'chirib qo'ying",
    "Loading": "Yuklanmoqda",
    "Choose a transporter": "Tashuvchi tanlang",
    "Choose a bus model": "Avtobus modelini tanlang",
    "Choose a driver": "Haydovchini tanlang",

    "Creation": "Yaratilish",
    "Types of buses (creation - editing)": "Avtobus turlari (yaratish - tahrirlash)",
    "How many floors": "Qancha qavat",
    "First floor": "Birinchi qavat",
    "Second floor": "Ikkinchi qavat",
    "Swap From": "bilan almashtirish",
    "Created place": "Joyni yaratish",
    "Created a place for the disabled": "Nogironlar uchun joy yaratildi",
    "Created place for passengers with children": "Bolalar bilan yo'lovchilar uchun joy yaratildi",
    "Floors": "Qavatlar",
    "Create a new type": "Yangi turni yarating",
    "Users": "Foydalanuvchilar",
    "Name": "Ism",
    "Phone number": "Telefon raqami",
    "Type": "Turi",
    "Status user": "Foydalanuvchi holati",
    "Confirm the password": "Parolni tasdiqlang",
    "Select user type": "Foydalanuchi turini tanlang",
    "Refresh": "Yangilash",
    "Old Password": "Eski parol",
    "Password": "Parol",
    "Employee's role": "Xodimning roli",
    "Add roles": "Rol qo'shish",
    "New Password": "Yangi parol",
    "Confirmed Password": "Parolnio takrorlash",
    "Your password has been successfully updated": "Siznign paroling muvaffaqiyatli yangilandi",
    "Role users": "Foydalanuvchi rollari",
    "Number of permissions": "Ruxsatlar soni",
    "Number of users": "Foydalanuchilar soni",
    "User Roles (Creation)": "Foydalanuvchi roli (yaratilish)",
    "Please select at least one permission": "Iltimos, kamida bitta ruxsatni tanlang",
    "additional trips": "qo'shimcha reyslar",
    "Actualize": "Haqiqiylashtirish",
    "Send trips": "Raysni jo'natish",
    "Cancel trips": "Reysni bekor qilish",
    "Change trips": "Reysni o'zgartirish",
    "Has arrived": "Keldi",
    "Statement": "Rasmiy hisobot",
    "List": "Ro'yxat",
    "Passenger": "Yo'lovchi",
    "Passengers": "Yo'lovchilar",
    "Export to Excel": "Excel ga export",
    "Select": "Tanlang",
    "Trip date": "Reyslar vaqti",
    "Point of departure": "Jo'nash joyi",
    "Select stations": "Stantsiyalarni tanlang",
    "date": "Sana",
    "Capacity": "Sig'imi",
    "Number of occupied places": "Egallagan joylar soni",
    "Platform": "Platformalar",
    "Amount": "Summa",
    "trip": "reys",
    "To send": "Jo'natish",
    "Bus number": "Avtobus raqami",
    "Bus brand": "Avtobus raqami",
    "Cancel": "bekor qilish",
    "Place": "Joy",
    "Cost": "Narxi",
    "You cannot disable this trip because it has active passengers.": "Siz ushbu safarni o'chirib qo'ya olmaysiz, chunki u faol yo'lovchilarga ega.",
    "STATEMENT": "RASMIY HISOBOT",
    "LIST": "RO\"YXAT",
    "Passengers transported in international road transport": "Yo'lovchilar xalqaro avtomobil tashishda tashiladi",
    "attached to the ticket list": "chiptalar ro'yxatiga biriktirilgan",
    "Date and time of departure": "Ketish sanasi va vaqti",
    "Bus model": "Avtobus modeli",
    "Trip": "Reys",
    "Issued by": "Chiqarilgan",
    "Departure": "Jo'natilgan",
    "Number of citizenship": "Fuqarolik bo'yicha soni",
    "FULL NAME": "F.I.O",
    "Places": "Joylar",
    "Year of birth": "Tug'ulgan sana",
    "Passport Series and No.": "Pasport seriyasi va raqami",
    "Citizenship": "Fuqarolik",
    "Until where": "Qayergacha",
    "Ticket price": "Chipta narxi",
    "Tickets": "Chiptalar",
    "Total amount": "Umumiy miqdori",

    "Loading data": "Ma'lumotlar yuklanmoqda",
    "Route": "Yo'nalish",
    "Departure time": "Chiqish vaqti",
    "Price entry": "Narxlar kiritilishi",
    "Name ATP": "ATP nomi",
    "Bank": "Bank",
    "MFO": "MFO",
    "Checking account": "Hisob raqami",
    "Percentage per passenger": "Bir yo'lovchi uchun foiz",
    "Percentage per baggage": "Bagaj uchun foiz",
    "Price / km": "Narx / km",
    "Find": "Qidirish",
    "Locality": "Aholi punkti",
    "Adress": "Manzil",
    "Operation mode": "Ish tartibi",
    "Coordinates": "Koordinatalari",
    "Place of bus station (optional)": "Avtobus bekatlarining joylashuvi (ixtiyoriy)",
    "Also known as": "Bundan tashqari, huddi",
    "day": "kun",
    "Pre-sale fee": "Oldindan sotish uchun yig'im",
    "sum": "сум",
    "Presale - for sale for more than": "Oldindan sotish - ko'proq sotuvga chiqariladi",
    "o'clock": "soat",
    "Reserved seats": "Rezervlangan o'rindiqlar",
    "become available for": "uchun foydalanish mumkin",
    "minutes before sending": "yuborishdan oldin daqiqa",
    "Customize information board color scheme": "Ma'lumot kartasi ranglarini moslashtiring",
    "Background 1": "Orqa fon 1",
    "Text color 1": "Tekst rangi 1",
    "Background 2": "Orqa fon 2",
    "Text color 2": "Tekst rangi 2",
    "Show report": "Hisobotlarda ko'rsatilsin",
    "Schedule Flights (Creation)": "Reyslarni rejalashtirish (yaratilish)",
    "Choose a route": "Yo'nalishni tanlang",
    "Trip number": "Reys nomer",
    "Arrival": "Kelishi",
    "On the way": "Yo'lda",
    "Each": "Har bir",
    "Mon": "Du",
    "Tu": "Se",
    "We": "Ch",
    "Th": "Pa",
    "Fr": "Ju",
    "Sa": "Sh",
    "Su": "Ya",
    "Various": "Har xil",
    "Even": "Juflar",
    "Odd": "Toqlar",
    "For example 1-5, 9, 13": "Masalan 1-5, 9, 13",
    "Days": "Дни",
    "Beginning with": "Boshlanish vaqti",
    "Ends at": "Tugash vaqti",
    "Choose a bus": "Avtobusni tanlang",
    "Automatic update": "Avtomatik yangilash",
    "International flight": "Xalqaro reys",
    "Parking": "To'xtov joyi",
    "Send": "Jo'n.",
    "Comment": "Fikr",
    "Choose a rate": 'Tarifni tanlang',
    "Flights schedule": "Reyslar jadvali",
    "Deactivate": "O'chirish",
    "Destination": "Manzil",
    "Regularity": "Muntazamlik",
    "Turned off": "Yopiq",
    "Schedule Flights (Change)": "Parvozlarni rejalashtirish (o'zgartirish)",
    "Change": "O'zgartirish",
    "Clear trail flights and generate new ones": "Izni tozalang reyslar va yangilarini ishlab chiqaradi",
    "Filter": "Filtrni tanlang",
    "- day": "- kun",
    "Route number": "Yo'nalish raqami",
    "Add station": "Stansiyani qo'shish",
    "Select a station to add": "Qo'shiladigan stantsiyani tanlang",
    "Choose": "Tanlang",
    "Km": "Km",
    "Tit.": "Nomi",
    "Fault return": "Aybi bo'yicha qaytarish",
    "Fine": "Shtraf",
    "ATP": "ATP",
    "Passenger after flight departure": "Yo'lovchi parvozdan keyin yo'lovchi",
    "The return of the fault of the passenger to the departure of the flight": "Yo'lovchining aybi tufayli parvozni tark etishga qaytarish",
    "Creating benefits": "Manfaatlar yaratish",
    "Route Name": "Yo'nalish nomie",
    "Write down": "Yozish",
    "Add": "Qo'shish",
    "Bus terminal": "Avtovokzal",
    "Login": "Login",
    "Enter": "Kirish",
    "Location": "Turgan joyi",
    "Geography": "Geografiya",
    "Prochee": "Boshqalar",
    "Cashiers": "Kassirlar",
    "Full name": "Ism Familiya",
    "Passport number": "Pasport raqami",
    "Number place": "Joy nomeri",
    "Trips (creation)": "Reys (o'zgartirish)",
    "Bus": "Avtobus",
    "Region": "Viloyat",
    "Stations" : "Stansiya",
    "Privilege" : "Imtiyozlar",
    "Return service" : "Xizmatni qaytarish",
    "Bus type" : "Avtobus turi",
    'Country': 'Davlat',
    'Conductor' : 'Konduktor',
    'Reports' : 'Hisobotlar',
    'Reversals': 'Qaytarilgan biletlar',
    "You are about to delete the record! \nAre you sure?" : 'Yozuvni o\'chirib tashlamoqchisiz!\n' +
        'Ishonchingiz komilmi?',
    "Registration" : "Registrasiya",
    "Tariff": "tarif",
    "Fine (percentage)" : "Shtraf(prosentda)",
    "No. ticket" : "Chipta raqami",
    "Role has been saved successfully" : "Rol muvaffaqiyatli saqlandi.",
    "Select service type" : "Xizmat turini tanlang",
    "Choose a baggage type" : "Bagaj turini tanlang",
    "Name trip" : "Reys nomi",
    "Choose region" : "Viloyat nomi",
    "Place of residence" : "Ro'yxatdan o'tgan manzili",
    "Save" : "Saqlash",
    "Do you really want to delete this bus station?" : "Siz ushbu avtobus bekatini o'chirmoqchimisiz?",
    "Settings saved!" : "Sozlamalar saqlandi!",
    "Depth of sales" : "Sotish chuqurligi",
    "Presale": "Oldindan savdo",
    "Place quotas" : "Joylarda kvotalar",
    "Bus station services" : "Avtovokzal xizmatlari",
    "Required " : "Majburiy",
    "Show in reports": "Hisobotlarni ko'rsatish",
    "Bus station collection" : "Avtovokzal yig'imi",
    "All passengers moved to a new journey." : "Barcha yo'lovchilar yangi safarga ko'chishdi.",
    "HOT !!! Do you really want to delete all trips that start tomorrow and generate new ones?" : "EHTIYOT BO'LING !!! Ertaga boshlaydigan barcha sayohatlarni o'chirishni va yangilarini yaratishni xohlaysizmi?",
    'Successfully!!!' : 'Muvaffaqiyatli!',
    'Saved!' : 'Saqlandi!',
    'min' : 'min',
    'h' : 'soat',
    'Basic' : 'Asosiy',
    'Do you really want to delete flight schedules?' : 'Parvoz jadvallarini o\'chirishni xohlaysizmi?',
    "You are about to delete the record \nAre you sure?" : "Yozuvni o'chirib tashlamoqchisiz! \n Ishonchingiz komilmi?",
    "Surname" : "Familiya",
    "Middle name" : "Otasini ismi",
    "Do you really want to change the status?" : "Siz haqiqatdan ham holatimi o'zgartirmoqchimisiz?",
    "Changed status" : "Holatni o'zgartish",
    "Failed to change" : "O'zgarish amalga oshmadi",
    "Do you really want to delete?" : "Siz haqiqatdan ham yo'q qilishni xohlaysizmi?",
    "Departure date" : "Chiqish sanasi",
    "Number of passengers" : "Yo'lovchilar soni",
    "Generate month report" : "Oylik hisobot tuzish",
    "Generate daily report" : "Kundalik hisobotni yarating",
    "Filter by date from" : "Sana bo'yicha filtrlash",
    "by" : "bo'yicha",
    "To form" : "Yaratish",
    "Car number" : "Avto raqami",
    "Count beat" : "Кол. бил",
    "Plan" : "Plan",
    "Fact" : "Fakt",
    "Pass" : "Yo'l",
    "Bag" : "Bag",
    "Full name of the driver" : "Haydovchini F.I.O si",
    "Cash" : "Naqd",
    "Term" : "Term",
    "Print out" : "Chiqarish",
    "Total": "Jami",
    "Last day" : "Oxirgi kun",
    "since the beginning of the week" : "Haftaning boshidan beri",
    "from the beginning of the month" : "oyning boshidan boshlab",
    "from the beginning of the year" : "yil boshidan beri",
    "trips" : "Reyslar",
    "passenger" : "Yo'lovchi",
    "all places" : "hamma joylar",
    "Name of the Cashier" : "Kassir F.I.O si",
    "Sold tickets": "Sotilgan chiptalar",
    "Including" : "Shu jumladan",
    "Returned tickets" : "Qaytgan chiptalar",
    "Sold tickets with no refund" : "Qaytarilmasdan chipta sotilgan",
    "Number of booking.\n places" : "Bron. qilingan joylar soni",
    "count" : "soni",
    "amount":"summa",
    "Sold Services" : "Sotilgan xizmatlar",
    "baggage amount" : "Bagaj summasi",
    "Cashier" : "Kassir",
    "All passengers" : "Hamma yo'lovchilar",
    "Village of passengers" : "O'tirgan yo'lovchilar soni",
    "No passengers" : "O'tirmagan yo'lovchilar soni",
    "Booked seats" : "Bron qilingan joylar",
    "Canceled tickets" : "Bekor qilingan biletlar",
    "others" : "boshqalar",
    "Selected passengers" : "Tanlangan yo'lovchilar",
    "Selected Village of passengers" : "Tanlangan O'tirgan yo'lovchilar",
    "Selected No passengers village" : "Tanlangan O'tirmagan yo'lovchilar",
    "Selected Canceled Tickets" : "Tanlangan Bekor qilingan biletlar",
    "Selected Returned Tickets" : "Tanlangan Qaytarilgan biletlar",
    "Selected others" : "Tanlangan boshqalar",
    "Amount of selected passengers" : "Tanlangan yo'lochilar summasi",
    "No reports" : "Hisobot yo'q",
    "Everything" : "Hammasi",
    "Village" : "O'tirgan",
    "Not village" : "O'tirmagan",
    "Booked" : "Bron qilingan",
    "Canceled" : "Bekor qilindi",
    "Cancelled" : "Bekor qilingan",
    "Returned" : "Qaytarilgan",
    "other" : "boshqalar",
    "Armored" : "Bron",
    "Did not come" : "Kelmagan",
    "Had arrived" : "Kelgan",
    "Canceled for non-payment" : "To'lanmaslik uchun bekor qilingan",
    "Validators report" : "Tekshiruvchi hisoboti",
    "Name of Validator" : "Tekshiruvchi F.I.O si",
    "Trip time" : "Reys vaqti",
    "minimum length is 3" : "minimal uzunligi 3",
    "maximum length is 150" : "maksimal uzunligi 150",
    "can only be used" : "faqat ishlatilishi mumkin",
    "required field" : "kerakli maydon",
    "cyrillic letters" : "Kirill harflari",
    "latin letters" : "Lotin harflari",
    "Do you really want to delete this flight?" : "Ushbu resyni chindan ham o'chirib tashlamoqchimisiz?",
    "Passenger removed!" : "Yo'lovchi o'chirilgan!",
    "Trip has been created successfully" : "Reys muvaffaqiyatli yaratildi",
    "Arrived" : "Kelgan",
    "You are about to delete the record!\nAre you sure?": "Yozuvni o'chirib tashlamoqchisiz!\n" +
        "Ishonchingiz komilmi?",
    "This stop has already been added to the route." : "Ushbu bekat allaqachon marshrutga qo'shilgan.",
    "Count users" : "Foydalanuvchilar soni",

    //    infokiosk_web
    "Sale tickets at the price of a bus station": "Avtovokzal narxida chiptalarni sotish",
    "Ticket Recovery": "Chiptalarni tiklash",
    "Next": "Keyingi",
    "Enter phone number": "Telefon raqamini kiriting",
    "Submit Code": "Kodni yuboring",
    "Get my tickets": "Mening chiptalarimni oling",
    "Data": "Ma'lumot",
    "Reys": "Reys",
    "Ticket": "Chipta",
    "No tickets": "Chiptalar yo‘q",
    "Ministry of Transport of the Republic of Uzbekistan": "O'zbekiston Respublikasi transport vazirligi",
    "All rights reserved": "Barcha huquqlar himoyalangan",
    "Portal developed": "Portal ishlab chiqilgan",
    "There is no train station in this location yet": "Ushbu joyda hali vokzal mavjud emas",
    "Reys on": "Reyslar uchun",
    "reys": "reys",

    "Reserved places will be cleared through": "Zaxiralangan joylar orqali tozalanadi",
    "Free": "Bo`sh",
    "Busy": "Band",
    "Reserve": "Rezervga olingan",
    "Selected": "Tanlangan",
    "Checkout": "Buyurtma",
    "Phone": "Telefon",
    "E-mail": "E-mail",
    "required fields": "majburiy maydonlar",
    "For paying": "To'lash uchun",
    "Payment": "To'lov",
    "Card number": "Karta raqami",
    "Card expiry date": "Kartaning amal qilish muddati",
    "Send SMS Code": "SMS kodini yuboring",
    "Pay": "To'lash",
    "SMS-CODE": "SMS KODI",
    "Take a picture or": "Rasmga oling yoki",
    "Count empty seats": "Bo'sh joylar soni",
    "Rate (summa)": "Tarif (so'mma)",
    "This seat is selected by other user": "Ushbu joy boshqa yo'lovchi tomonidan tanlangan",
    "The bus does not go on the indicated date": "Avtobus belgilangan sanada ketmaydi",
    "Where to": "Qayerga",
    "When": "Qachon",
    "Tashkent": "Toshkent",
    "Back": "Ortga",
};

export default data;
